import { Skeleton } from '@avanta/shared/components/ui/Skeleton';
import { cn } from '@avanta/shared/utils/cn';
import { CONTAINER_MD_MAX_WIDTH } from '../../../../styles';

const SPECIALITIES_COUNT = 4;
const CONTACT_METHODS_COUNT = 2;

const CardSkeleton = ({ className }: { className?: string }): React.ReactElement => (
  <div
    className={cn(
      'flex w-full px-3.5 py-2 am-lg:py-4 flex-col items-center justify-center gap-1 am-lg:gap-2 rounded-xl',
      'bg-white border border-gray-300 shadow-md',
      className
    )}
  >
    <Skeleton className="size-8 rounded-full" />
    <Skeleton className="h-3.5 w-2/3" />
  </div>
);

export const SpecialitySkeleton = (): React.ReactElement => (
  <div className={cn(CONTAINER_MD_MAX_WIDTH, 'flex flex-col gap-8 am-lg:gap-10')}>
    <div className="flex flex-col gap-4">
      <Skeleton className="h-5 w-80" />
      <div className="grid grid-cols-2 am-lg:grid-cols-4 gap-4">
        {Array.from({ length: SPECIALITIES_COUNT }).map((_, index) => (
          <CardSkeleton key={`speciality-${index}`} className="h-20 am-lg:h-24" />
        ))}
      </div>
    </div>
    <div className="flex flex-col gap-4">
      <Skeleton className="h-5.5 w-70" />
      <div className="grid grid-cols-2 gap-4">
        {Array.from({ length: CONTACT_METHODS_COUNT }).map((_, index) => (
          <CardSkeleton key={`contact-method-${index}`} />
        ))}
      </div>
    </div>
    <div className="flex justify-end">
      <Skeleton className="h-11 w-full am-lg:w-35 rounded-full" />
    </div>
  </div>
);
